<template>
  <div ref="chartdiv" class="chart" :class="{chart_loading: !chartLoaded}"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.options.commercialLicense = true;
const colorArr = [
  // "#000",
  "#0065b8",
  "#2b7b90",
  "#87c6d7",
  "#652b96",
  "#a896c0",
  "#b80001",
  "#d58b89"
];
const labelMap = {
  // rcpCount: "대상자수 전체",
  utteranceRequest_allCount: "호출건수 전체",
  utteranceRequest_newsCount: "소식톡톡",
  utteranceRequest_gameCount: "두뇌톡톡",
  utteranceRequest_dementiaCount: "기억검사",
  utteranceRequest_goodCount: "좋은생각",
  utteranceRequest_mindCount: "마음체조"
};

export default {
  props: {
    chartData: {
      type: Array
    }
  },
  data() {
    return {
      chart: null,
      chartLoaded: false
    };
  },
  watch: {
    chartData(val) {
      this.dispose();
      if (val) this.delayDraw();
    }
  },
  methods: {
    draw() {
      this.chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
      this.chart.paddingRight = 20;
      this.chart.data = this.chartData;

      const categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "date";

      const dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;

      const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      // valueAxis.tooltip.disabled = true;
      valueAxis.renderer.minWidth = 35;

      let colorCounter = 0;
      _.forEach(this.chartData[0], (item, key) => {
        if (!labelMap[key]) return;
        const name = labelMap[key];
        const color = colorArr[colorCounter % colorArr.length];
        const series = this.chart.series.push(new am4charts.LineSeries());
        const bullet = new am4charts.CircleBullet();
        bullet.scale = 0.6;
        series.dataFields.categoryX = "date";
        series.dataFields.valueY = key;
        series.name = name;
        series.stroke = am4core.color(color);
        series.fill = am4core.color(color);
        series.strokeWidth = 2;
        series.bullets.push(bullet);
        colorCounter++;
      });
      this.chart.legend = new am4charts.Legend();
      this.chart.legend.position = "right";
      this.chart.legend.width = 90;
      this.chart.events.on("shown", this.onChartLoaded);
    },
    onChartLoaded() {
      this.chartLoaded = true;
    },
    dispose() {
      if (this.chart) this.chart.dispose();
    },
    // 바로 그리면 그래프때문에 렌더시간이 너무 오래걸림. 그래프만 나중에
    delayDraw() {
      setTimeout(() => this.draw(), 30);
    }
  },
  mounted() {
    if (!_.isEmpty(this.chartData)) this.delayDraw();
  },
  beforeDestroy() {
    this.dispose();
  }
};
</script>
